import { render, staticRenderFns } from "./TopBannerNotice.vue?vue&type=template&id=9d4b1c8e&scoped=true&"
import script from "./TopBannerNotice.vue?vue&type=script&lang=js&"
export * from "./TopBannerNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4b1c8e",
  null
  
)

export default component.exports